import { render } from "./MatchPointsView.vue?vue&type=template&id=ca4ff814&scoped=true"
import script from "./MatchPointsView.vue?vue&type=script&lang=js"
export * from "./MatchPointsView.vue?vue&type=script&lang=js"

import "./MatchPointsView.vue?vue&type=style&index=0&id=ca4ff814&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4ff814"]])

export default __exports__